export const defaultUserPhoto = `${process.env.REACT_APP_API_BASE}/media/static/images/default_profile.png`;
